module.exports = __webpack_public_path__ + "static/media/VectorBack.5bb333a5.svg";